import React, { Component } from 'react'
import {BrowserRouter as Router,Link, Redirect, Route } from 'react-router-dom';
import ExamList from '../cms/ExamList';
import '../css/Admin_css/admin-customize.css';
import icom_report_card from '../resources/icons/icons_report_card100_white.png'
import COLORS from '../resources/colors/COLORS';
import axios from 'axios';
import MyLoader from '../Spinner/MyLoader';
import SessionManager from '../Utils/SessionManager';
import myToast from '../Utils/MyToast';
import ReportViewClass from './ReportViewClass';
import StudentData from './StudentData';
export default class DataCenter extends Component {
  constructor(props){
    super(props)
    const token=localStorage.getItem("token");
    let loggedIn=true;
    if(token==null){
      loggedIn=false;
    }
  
    this.state={
  
        loggedIn:true,
        Loading:false, 
        mDataCenter:[],
        
    }
  
  }
  componentDidMount()
  {
     window.scrollTo(0, 0);
     this.getReportMaster();
  }
  getReportMaster(){
  
  this.setState({
    Loading:true
  })
  const SCHOOL_CODE=SessionManager.getSchoolCode();
  var mStaffData=SessionManager.getStaffDetails();
  var STAFF_ID=mStaffData.staff_id;
  const FUNCTION_NAME='getDataCenterMaster.php'
  URL=process.env.REACT_APP_SERVER_NAME+process.env.REACT_APP_TARGET_DIR+FUNCTION_NAME
  console.log("URL>>>>>"+URL)  
  axios.get(URL,{
    params:{staff_id:STAFF_ID,school_code:SCHOOL_CODE}
  }).then(res => res.data)
  .then((response) => {
    this.setState({ 
      Loading:false
     })
     // console.log("Response2>>>>>"+response);
      let api_status=response.api_status;
      // alert(api_status);
      
      if(api_status=="OK")
      {
      
         this.setState({
          
            mDataCenter:response.data
          })
         
      }
      else{
        let api_remark=response.api_remark;
        myToast.notify_warning(api_remark);
      }
  
    //console.log("response>>>>>"+api_status)
   }).catch((error)=>{
    this.setState({ 
      Loading:false
     })
    console.log("error>>>>>"+error);
    });
  }
    render() {
      return (
      
        <Router>
          <switch>
            <Route path={'/AdminMain/DataCenter'}  exact render={
              ()=>{
            return(
  
                 <div className="content">
            <div className="content-header">
              <div className="leftside-content-header">
                <ul className="breadcrumbs">
                  <li><i className="fa fa-home" aria-hidden="true" /><a href="#">Data Center </a></li>
                </ul>
              </div>
            </div>
                <div className="row animated fadeInUp bg_page_grey_rounded box_shadow" style={{'--mMargin':'50px',marginTop:'20px'}}>
                 
                {this.state.mDataCenter.map((item, index) => (
                    <div className="col-sm-4 col-md-4" style={{padding:'10px'}}>
                    <Link to={'/AdminMain/'+item.component_name+"/"+item.file_directory+"/"+item.file_name}>
                    <div className="row class-list-box">
                    <div className="col-sm-4" style={{background: COLORS.primary_color_shade6,padding:'1em'}}>
                      <div>
                            <img src={icom_report_card} className="admission-dashboard-img" alt="student list image"/>
                        </div>
                    </div>
                    <div className="col-sm-8 gravity_center">
                    <h4 className="text-center">{this.state.mDataCenter[index].data_caption} </h4>
                    </div>
                    </div>
                    </Link>
                    </div>
                         
               ))}


  

                  </div>
                 </div>
    
              )
             }
           } />
  
      <Route path='/AdminMain/StudentData/:file_directory/:file_name/'  component={StudentData} />
     
  </switch>
  
  </Router>
    )
    }
}
